import { Icon } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { PageContent } from 'components/layout/PageContent'
import { PageHeaderSection } from 'components/PageHeaderSection'
import { ButtonLink } from 'components/route'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions.generated'

import PerfilTable from './PerfilTable'

export default function PerfilListView() {
  const match = useRouteMatch()

  return (
    <>
      <PageHeaderSection
        title='Perfis'
        action={
          <CheckPermission permission={Permissions.visualizarPerfis.cadastrarEditarEExcluir}>
            <ButtonLink to={`${match.url}/cadastro`} kind='primary'>
              <Icon icon='plus' style={{ marginRight: '0.5rem' }} />
              Cadastrar perfil
            </ButtonLink>
          </CheckPermission>
        }
      />

      <PageContent>
        <PerfilTable />
      </PageContent>
    </>
  )
}
